
import * as React from 'react';
import { connectToItemCache } from '../../decorators/connectToItemCache';
import { IItemCache } from '../../../models/IItemCacheObserver';
import { IActionProps, Action } from '../../action/Action';
import { withSelectedItems, withExactlyOneItem } from '../../decorators/selectors';
import { openUrlFacet } from '../../../facets/ItemFacets';
import { targetWindowControl } from '../../../controls/targetWindowControl';
import { getItemActionEngagement } from '../../../models/telemetry/getItemEngagement';
import { IEngagementData } from '../../../facets/LoggerFacets';
import { graft } from '../../../utilities/Graft';

const doNothing = async () => { /* Nothing */ };

/**
 * @public
 */
export interface IItemOpenUrlActionProps {
    itemKey: string;
    engagement?: Partial<IEngagementData>;
}

/**
 * @public
 */
export const ItemOpenUrlAction: React.ComponentType<IItemOpenUrlActionProps> = connectToItemCache((
    itemCache: IItemCache,
    props: IItemOpenUrlActionProps
): IActionProps => {
    const {
        itemKey,
        engagement
    } = props;

    const {
        openUrl,
    } = itemCache.demandItem({
        openUrl: openUrlFacet,
    }, itemKey);

    const targetWindowControlHandler = itemCache.demandItemFacet(targetWindowControl, undefined);

    const {
        targetWindow
    } = targetWindowControl.evaluate(targetWindowControlHandler)(itemCache, {});

    return {
        isAvailable: !!openUrl,
        onExecute: openUrl ? async () => {
            if (targetWindow) {
                targetWindow.location.href = openUrl;
            } else {
                window.open(openUrl);
            }
        } : doNothing,
        ...getItemActionEngagement(itemCache, {
            itemKey,
            engagement: graft({
                name: 'OpenUrl',
                isIntentional: true
            }, engagement)
        })
    };
})(Action);

/**
 * @public
 */
export const OpenUrlAction: React.ComponentType<{}> = withSelectedItems()(withExactlyOneItem()(ItemOpenUrlAction));
